import { defineComponent, computed } from '@vue/composition-api';
import { SurveyStatus } from '@/api/v2/requests/surveys';
import { date } from '@/util/formatters';
import { mdiCalendarMonthOutline, mdiArrowLeft, mdiTextBoxOutline, mdiChartLine, mdiCheckCircleOutline, mdiAlertOutline, mdiAlertOctagonOutline, } from '@mdi/js';
import { Icon, IconSize } from '@/components/Icon';
import SurveyStatusBadge from '@/views/Brand/Surveys/_components/SurveyStatusBadge.vue';
import { surveyStatusStyles } from '@/views/Brand/Surveys/_constants/survey-status';
export default defineComponent({
    name: 'SurveyHeader',
    components: {
        Icon,
        SurveyStatusBadge,
    },
    props: {
        survey: {
            type: Object,
            required: true,
        },
        aggregatedStatus: {
            type: String,
            required: false,
            default: null,
        },
    },
    setup(props) {
        const getProgressPercentage = (survey) => {
            if (!survey.totalUsers || survey.totalUsers === 0)
                return 0;
            return Math.round((survey.completedUsers / survey.totalUsers) * 100);
        };
        const statusIcon = computed(() => {
            const status = props.aggregatedStatus;
            if (status === SurveyStatus.NEEDS_REVISION) {
                return mdiAlertOutline;
            }
            else if (status === SurveyStatus.REJECTED) {
                return mdiAlertOctagonOutline;
            }
            return null;
        });
        const statusColor = computed(() => {
            const status = props.aggregatedStatus;
            if (status === SurveyStatus.NEEDS_REVISION) {
                return surveyStatusStyles[SurveyStatus.NEEDS_REVISION]?.color;
            }
            else if (status === SurveyStatus.REJECTED) {
                return surveyStatusStyles[SurveyStatus.REJECTED]?.color;
            }
            return null;
        });
        return {
            date,
            getProgressPercentage,
            statusIcon,
            statusColor,
            mdiCalendarMonthOutline,
            mdiArrowLeft,
            mdiTextBoxOutline,
            mdiChartLine,
            mdiCheckCircleOutline,
            IconSize,
        };
    },
});
